import { PolicyValidator, Policy, checkLicense, checkScope } from '../policy.interface';

export const scopes = {
    CREATE_ORDER: 'client_stamp:CREATE_ORDER',
    VIEW_ORDERS: 'client_stamp:VIEW_ORDERS',
};

const appPolicy = {
    validate: (policy: Policy) => {
        return checkLicense(policy, 'client_stamp');
    },
    ...Object.fromEntries(
        Object.entries(scopes).map(([key, value]) => [
            `can${key.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join('')}`,
            (policy: Policy) => checkScope(policy, value)
        ])
    )
} as any; 

export default appPolicy;
